<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue'

  import SvgIcon from '@shared/components/svg-icon.vue'

  import type { ElInput } from 'element-plus'

  const props = defineProps<{
    modelValue: string
    label?: string
    isTag?: boolean
    tagIcon?: string
    tagName?: string
  }>()
  const emit = defineEmits(['update:modelValue', 'on-clear'])

  onMounted(() => {
    inputSearchRef.value?.input?.setAttribute('value', props.modelValue)
  })

  const inputSearchRef = ref<InstanceType<typeof ElInput>>()

  const inputVal = computed({
    get() {
      return props.modelValue
    },
    set(newVal) {
      inputSearchRef.value?.input?.setAttribute('value', newVal)
      emit('update:modelValue', newVal)
    },
  })

  const handleClear = () => {
    emit('on-clear')
  }
</script>

<template>
  <el-form-item class="c-search" :label="label">
    <el-input v-model="inputVal" v-bind="$attrs" ref="inputSearchRef">
      <template #prefix>
        <div class="tw-flex tw-items-center">
          <svg-icon name="search" size="24" class="tw-fill-primary-100" />
          <div v-if="isTag" class="tw-ml-8 tw-py-2 tw-px-6 tw-rounded-24 tw-bg-secondary-100">
            <div class="tw-flex tw-items-center">
              <svg-icon class="tw-fill-primary-100" :name="tagIcon || ''" size="24" />
              <div class="tw-ml-6 tw-text-subtitle-1 tw-text-primary-100">{{ tagName }}</div>
            </div>
          </div>
        </div>
      </template>
      <template #suffix>
        <svg-icon
          v-if="modelValue"
          class="tw-fill-grey-600 tw-cursor-pointer"
          name="remove"
          size="12"
          @click="handleClear"
        />
      </template>
    </el-input>
  </el-form-item>
</template>

<style lang="scss">
  .c-search {
    .el-input {
      @apply tw-h-48 tw-text-subtitle-1;

      &__wrapper {
        @apply tw-shadow-400 tw-bg-grey-300 tw-py-10 tw-px-14 tw-border tw-border-transparent tw-transition-all;

        &:hover {
          @apply tw-border-primary-100;
        }

        &:active,
        &:focus,
        &.is-focus {
          @apply tw-shadow-500 tw-border-primary-100;
        }
      }
    }
  }
</style>
